import { Button } from '@repo/foundations';

interface AcceptRequestButtonProps {
	applied?: boolean;
	onAccept: () => void;
}

export function AcceptRequestButton({
	applied,
	onAccept,
}: AcceptRequestButtonProps) {
	return (
		<Button disabled={applied} onClick={onAccept} size="md">
			{applied ? 'Applied' : 'Accept'}
		</Button>
	);
}
